import {useEffect} from "react";
import {useAppSelector} from "../hooks";
import {selectUser} from "../actions/userSlice";
import {CONFIG} from "./config";

const usePageTracking = () => {

    const user = useAppSelector(selectUser)

    useEffect(() => {

        if (user) {

            (window as any).pendo.initialize({
                visitor: {
                    id: user.username,
                    full_name: user.firstName + ' ' + user.lastName,    // Recommended if using Pendo Feedback
                    email: user.username,       // Recommended if using Pendo Feedback, or NPS Email

                    // You can add any additional account level key-values here,
                    // as long as it's not one of the above reserved names.
                },

                account: {
                    id: user.company.hash,
                    name: user.company.name // Required if using Pendo Feedback

                    // You can add any additional account level key-values here,
                    // as long as it's not one of the above reserved names.
                }
            });
        }

    }, [user]);
}

const noop = () => {}

export default CONFIG.isPageTrackingEnabled ? usePageTracking : noop;
